/** Generated by @jobilla/openapi-codegen. Do not edit manually. */

import { queryOptions, useQuery, useSuspenseQuery } from '@tanstack/react-query'
import type {
	UseQueryOptions,
	UseQueryResult,
	UseSuspenseQueryOptions,
	UseSuspenseQueryResult,
} from '@tanstack/react-query'
import type { AxiosError, AxiosRequestConfig } from 'axios'
import { catalogueItemIndex } from '../../axios/catalogueItemIndex'
import type { CatalogueItemIndexError, CatalogueItemIndexResponse } from '../../types/CatalogueItemIndex'

export const catalogueItemIndexQueryKey = () => [{ url: '/catalogue-items' }] as const

export type CatalogueItemIndexQueryKey = ReturnType<typeof catalogueItemIndexQueryKey>

/** @see backend/nexus/modules/Billing/Http/Controllers/CatalogueItemController.php CatalogueItemController::index */
export function catalogueItemIndexQueryOptions(config?: AxiosRequestConfig) {
	return queryOptions<
		CatalogueItemIndexResponse,
		AxiosError<CatalogueItemIndexError>,
		CatalogueItemIndexResponse,
		CatalogueItemIndexQueryKey
	>({
		queryKey: catalogueItemIndexQueryKey(),
		queryFn: ({ signal }) => catalogueItemIndex({ signal, ...config }).then(res => res.data),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CatalogueItemController.php CatalogueItemController::index */
export function useCatalogueItemIndex<TSelectData = CatalogueItemIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseQueryOptions<
					CatalogueItemIndexResponse,
					AxiosError<CatalogueItemIndexError>,
					TSelectData,
					CatalogueItemIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseQueryResult<TSelectData, AxiosError<CatalogueItemIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useQuery({
		...catalogueItemIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}

/** @see backend/nexus/modules/Billing/Http/Controllers/CatalogueItemController.php CatalogueItemController::index */
export function useCatalogueItemIndexSuspense<TSelectData = CatalogueItemIndexResponse>(
	options?:
		& Partial<
			Omit<
				UseSuspenseQueryOptions<
					CatalogueItemIndexResponse,
					AxiosError<CatalogueItemIndexError>,
					TSelectData,
					CatalogueItemIndexQueryKey
				>,
				'queryKey' | 'queryFn'
			>
		>
		& { queryKey?: readonly unknown[] },
): UseSuspenseQueryResult<TSelectData, AxiosError<CatalogueItemIndexError>> {
	const { queryKey: customQueryKey, ...opts } = options ?? {}
	return useSuspenseQuery({
		...catalogueItemIndexQueryOptions(),
		...opts as any,
		...(customQueryKey ? { queryKey: customQueryKey as any } : {}),
	})
}
